<a class="cy-skip-link"
   href="#main-content">Skip to main content</a>
<link rel="stylesheet"
    href="https://fonts.googleapis.com/icon?family=Material+Icons">
<header>
    <public-app-header></public-app-header>
</header>
<main id="main-content"
      class="public-main"
      tabindex="-1">
    <router-outlet></router-outlet>
</main>
